
// 1-未完成 2-未开始 3-已完成
const status = {
    1: '未完成',
    2: '未开始',
    3: '已完成',
};
const examStatus = {
    1: '待审核',
    2: '待考试',
    3: '考试中',
    4: '待评卷',
    5: '不及格',
    6: '及格',
    7: '良好',
    8: '优秀'
};

const examstatusType = {
    1: '未发布',
    2: '发布中',
    3: '未开始',
    4: '报名中',
    5: '进行中',
    6: '已结束'
};

const resStatus = {
    1: '未发布',
    2: '未开始',
    3: '进行中',
    4: '已结束',
    5: '已撤销'
};
const resStatusColor = {
    1: '96,200,189', // 未发布
    2: '238,103,103', // 未开始
    3: '0,174,255', // 进行中
    4: '136,136,136', // 已结束
    5: '136,136,136', // 已结束
};
const resStatusPerson = {
    1: '待开始',
    2: '待参加',
    3: '已完成'
};
const genseeStatus = {
    0: '未发布',
    1: '未开始',
    2: '进行中',
    3: '已结束',
    4: '已撤销'
};

const genseeStatusColors = {
    0: '238,103,103', // 草案
    1: '96,200,189', // 草案
    2: '0,174,255', //  策划中
    3: '136,136,136', // 报名中
    4: '136,136,136', //  已撤销
};
const classStatusColors = {
    1: '96,200,189', // 草案
    2: '0,174,255', //  策划中
    3: '240,114,80', // 报名中
    4: '90,175,116', // 待实施
    5: '104,152,220', // 实施中
    6: '167,131,89', // 待结项
    7: '136,136,136', // 已结项
    8: '136,136,136', //  已撤销
};
const genseeIfJoinStatus = {
    0: '未参与',
    1: '已参与',
};
const studyStatus = {
    0: '未开始',
    1: '学习中',
    2: '已完成',
    3: '已放弃',
    4: '已完成',
    5: '待审核',
    6: '审核未通过'
};
const studyStatusColor = {
    0: '235,72,72',
    1: '96,200,189',
    2: '136,136,136',
    3: '136,136,136',
    4: '223,66,66',
    5: '167,131,89',
    6: '223,66,66'
};

const tranStatus = {
    1: '草案',
    2: '策划中',
    3: '报名中',
    4: '待实施',
    5: '实施中',
    6: '待结项',
    7: '已结项',
    8: '已撤销',
};
const graduateStatus = {
    1: '未结业',
    2: '已结业',
};
const examShowStatusColor = {
    1: '#333',
    2: '#5AAF74',
    3: '#6898DC',
    4: '#333333',
    5: '#DF4242',
    6: '#26AC77',
};
const examStatusColor = {
    1: '96,200,189', // 未发布
    2: '0,174,255', // 发布中
    3: '238,103,103', // 未开始
    4: '240,114,80', // 报名中
    5: '90,175,116', // 开考中
    6: '136,136,136', // 已结束
};

export default {
    status,
    examStatus,
    examstatusType,
    resStatus,
    resStatusPerson,
    tranStatus,
    genseeStatus,
    genseeStatusColors,
    genseeIfJoinStatus,
    studyStatus,
    studyStatusColor,
    classStatusColors,
    examShowStatusColor,
    examStatusColor,
    graduateStatus,
    resStatusColor
};
